module.exports = __webpack_public_path__ + "img/bgbox.3fd0a85c.png";